import { useMemo } from "react";
import { Lock, Globe, Moon, Info, LogOut, UserX, Shield } from "lucide-react";
import type { SettingItem } from "./settings-section";

interface SettingsSection {
  title: string;
  items: SettingItem[];
}

interface UseSettingsConfigProps {
  onNavigateToPasswordSecurity?: () => void;
  onNavigateToLanguageRegion?: () => void;
  isDarkMode?: boolean;
  onToggleDarkMode?: () => void;
  onNavigateToAbout?: () => void;
  onNavigateToTerms?: () => void;
  onNavigateToPrivacyPolicy?: () => void;
  onNavigateToPrivacy?: () => void;
  onNavigateToAccountDeletionPublic?: () => void;
  onLogoutClick?: () => void;
}

export function useSettingsConfig(props?: UseSettingsConfigProps) {
  const sections: SettingsSection[] = useMemo(
    () => [
      {
        title: "Conta",
        items: [
          {
            icon: Lock,
            label: "Senha e Segurança",
            subtitle: "Alterar senha, autenticação",
            action: () => {
              if (props?.onNavigateToPasswordSecurity) {
                props.onNavigateToPasswordSecurity();
              } else {
                alert("Em breve: Configurações de segurança");
              }
            },
          },
          {
            icon: Shield,
            label: "Privacidade e dados",
            subtitle: "Exportar, exclusão de conta e direitos LGPD",
            action: () => {
              if (props?.onNavigateToPrivacy) {
                props.onNavigateToPrivacy();
              } else {
                alert("Em breve: privacidade e dados.");
              }
            },
          },
        ],
      },
      {
        title: "Preferências",
        items: [
          {
            icon: Globe,
            label: "Idioma e Região",
            subtitle: "Português (Brasil)",
            action: () => {
              if (props?.onNavigateToLanguageRegion) {
                props.onNavigateToLanguageRegion();
              } else {
                alert("Em breve: Alterar idioma e região");
              }
            },
          },
          {
            icon: Moon,
            label: "Modo Escuro",
            subtitle: props?.isDarkMode ? "Ativado" : "Desativado",
            action: () => {
              if (props?.onToggleDarkMode) {
                props.onToggleDarkMode();
              }
            },
            toggle: true,
            value: props?.isDarkMode ?? false,
          },
        ],
      },
      {
        title: "Sobre",
        items: [
          {
            icon: Info,
            label: "Sobre o Aplicativo",
            subtitle: "Versão 1.0.0",
            action: () => {
              if (props?.onNavigateToAbout) {
                props.onNavigateToAbout();
              } else {
                alert("akihub v1.0.0\n\nSeu marketplace de produtos usados");
              }
            },
          },
          {
            icon: Info,
            label: "Termos de Uso",
            subtitle: "Políticas e termos",
            action: () => {
              if (props?.onNavigateToTerms) {
                props.onNavigateToTerms();
              } else {
                alert("Em breve: Termos de uso");
              }
            },
          },
          {
            icon: Info,
            label: "Política de Privacidade",
            subtitle: "Como usamos seus dados",
            action: () => {
              if (props?.onNavigateToPrivacyPolicy) {
                props.onNavigateToPrivacyPolicy();
              } else {
                alert("Em breve: Política de privacidade");
              }
            },
          },
          {
            icon: UserX,
            label: "Exclusão de conta e dados",
            subtitle: "LGPD e requisitos da loja de apps",
            action: () => {
              if (props?.onNavigateToAccountDeletionPublic) {
                props.onNavigateToAccountDeletionPublic();
              }
            },
          },
          ...(props?.onLogoutClick
            ? [
                {
                  icon: LogOut,
                  label: "Sair da conta",
                  subtitle: "Encerrar sessão neste aparelho",
                  variant: "destructive" as const,
                  action: () => props.onLogoutClick?.(),
                },
              ]
            : []),
        ],
      },
    ],
    [
      props?.onNavigateToPasswordSecurity,
      props?.onNavigateToLanguageRegion,
      props?.isDarkMode,
      props?.onToggleDarkMode,
      props?.onNavigateToAbout,
      props?.onNavigateToTerms,
      props?.onNavigateToPrivacyPolicy,
      props?.onNavigateToPrivacy,
      props?.onNavigateToAccountDeletionPublic,
      props?.onLogoutClick,
    ]
  );

  return sections;
}
